import { atom } from 'jotai';

import annotatorConstants from './annotator.constants';

export const fmxVersionAtom = atom<1 | 2 | undefined>(undefined);

export const latestImagesVisitDateAtom = atom<Date | undefined>(undefined);

export const showPastVisitsAtom = atom(false);

export const viewerModeAtom = atom(annotatorConstants.MODES.VIEWING);

export const imageFilterAtom = atom<string | undefined>(undefined);

export const sidebarIsNotCollapsedAtom = atom(true);

export const shouldDisplayRootTipsAtom = atom(true);
